// @flow
import * as React from 'react';

import {
    Cross,
    Filler,
    FillerIcon,
    Mask,
    MaskHiddenChild,
    OverlayIcon,
    SolidCircle,
    Spinner,
    SpinnerComponent,
    SpinnerContainer,
    SpinnerIcon,
    SpinnerPartsContainer,
    Tick
} from './styles';

import type { SaveState } from '~/core/constants/components/widgets/buttons/async';

type State = { saveState: SaveState };
export default ({ saveState }: State) => (
    <SpinnerComponent saveState={saveState}>
        <SpinnerContainer>
            <SpinnerPartsContainer saveState={saveState}>
                <Spinner>
                    <SpinnerIcon />
                </Spinner>
                <Filler>
                    <FillerIcon />
                </Filler>
                <Mask>
                    <MaskHiddenChild>.</MaskHiddenChild>
                </Mask>
                <OverlayIcon />
            </SpinnerPartsContainer>
            <Tick saveState={saveState} />
            <Cross saveState={saveState} />
            <SolidCircle saveState={saveState} />
        </SpinnerContainer>
    </SpinnerComponent>
);



// WEBPACK FOOTER //
// ./src/components/widgets/buttons/async/progress/index.js